(function(window){

	const $ = require('jquery');

	const toggleMenu = (e) => {
		e.preventDefault();
		$("#primary-nav").toggleClass("active");
	};

	const toggleParentNav = (e, btn) => {
		e.preventDefault();
		$(btn).toggleClass("active");
		$("#parent-nav").toggleClass("active");
	}

	$(document).ready(function(){
		$("[data-bind-ui=toggle-menu]").on("touchstart click", toggleMenu);
		$("[data-bind-ui=toggle-parent-nav]").on("click", function(e) {
			toggleParentNav(e, this);
		});
	});

})(window);
